export default __webpack_public_path__ + "static/media/1616071016_Home_Banner_19th_mar_d.03f35f5f.jpg";